/**
 * Component: src/theme/sections/search-hero.liquid
 */

let hasSearchHero = false;
let prevWindowWidth: number;
let clouds: HTMLElement;

const start = (force?: boolean) => {
  if (force || prevWindowWidth !== window.innerWidth) {
    prevWindowWidth = window.innerWidth;
    clouds = document.querySelector(".search-hero-clouds")!;
    cleanup();
    setTimeout(initSearchHeroClouds, 1);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".section-search-hero")) {
    hasSearchHero = true;
    initSearchHeroHover();
    prevWindowWidth = window.innerWidth;
    start(true);
  }
});

window.addEventListener("resize", () => {
  if (hasSearchHero) start();
});

const time = 30_000; // time (in ms) it takes for the clouds to move from start to end.

let timeout1;
let timeout2;
let timeout3;
let timeout4;
let timeout5;

const initSearchHeroClouds = () => {
  // Animate initial clouds
  clouds.style.transition = `all ${time}ms linear`;
  setTimeout(() => {
    clouds.style.left = `${window.innerWidth + 100}px`;
  }, 10);

  // Create and animate new clouds
  timeout1 = setTimeout(() => addCloud("20vh"), time / 3);
  timeout2 = setTimeout(() => addCloud("60vh"), time / 2);
  timeout3 = setTimeout(() => addCloud("30vh"), time - 1000);
  timeout4 = setTimeout(() => addCloud("100vh"), time / 3 + 2000);
  timeout5 = setTimeout(() => addCloud("120vh"), time - 4000);
};

const addCloud = (top: string) => {
  const cloudCopy = document.querySelector(".copy-this-cloud")?.cloneNode(true) as HTMLElement;
  cloudCopy.classList.add("search-hero-cloud-copy", "search-cloud-animate");

  cloudCopy.style.top = top;
  cloudCopy.style.left = `-${243}px`;
  cloudCopy.style.right = "";

  clouds.parentElement?.appendChild(cloudCopy);
};

const cleanup = () => {
  clearTimeout(timeout1!);
  clearTimeout(timeout2!);
  clearTimeout(timeout3!);
  clearTimeout(timeout4!);
  clearTimeout(timeout5!);
  document.querySelectorAll(".search-hero-cloud-copy")?.forEach((cloud) => cloud.remove());
  clouds.style.transition = "";
  clouds.style.left = "";
};

const initSearchHeroHover = () => {
  const apparels = document.querySelectorAll(".search-hero-apparel");

  apparels.forEach((apparel) => {
    const $apparel = apparel as HTMLImageElement;
    const originalSrc = $apparel.src;
    const hoverSrc = $apparel.dataset.hoverSrc;
    $apparel.addEventListener("mouseenter", () => {
      $apparel.src = hoverSrc;
    });
    $apparel.addEventListener("mouseleave", () => {
      $apparel.src = originalSrc;
    });

    // preload the hover image
    const img = new Image();
    img.src = hoverSrc;
  });
};
